import { useContext } from 'react';

import { ThemeContext } from './theme-context.js';

/**
 * Read the current theme and its controls.
 *
 * @returns {import('./theme-context.js').ThemeContextValue}
 * @throws {Error} when called outside a ThemeProvider. Loud rather than
 *   defaulting, so a component rendered in the wrong tree fails in development
 *   instead of quietly showing light mode in production.
 */
export function useTheme() {
  const value = useContext(ThemeContext);
  if (!value) {
    throw new Error('useTheme must be called inside a ThemeProvider');
  }
  return value;
}
